module.exports = __webpack_public_path__ + "bebad73b550dc031380b5515128c346a.svg";